module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-10.6b264d38.png";